'use strict';

import * as Props from '../Props';

const angular = require('angular');

const RadioProperties = {
    Basic: {
        'ControlType': 'Radio',
        'Label': {
            name: 'label',
            selectedValue: 'Radio',
            type: 'textbox',
            onClickFunction: 'openLanguageDialog',
            addOnButton: 'fa fa-globe'
        },
        'Field Name': Props.getFieldName('Radio'),
        'Data Field Name': Props.getDataFieldName('Radio'),
        'Display Format' : {
            name: 'display.format',
            type: 'dd',
            options: [
                {
                    value: 'radio',
                    key: 'Flat Radio Buttons',
                    icon: 'flat-radio'
                }, {
                    value: 'fRadioButtons',
                    key: 'Futrico Radio Buttons',
                    icon:'futrico-radio'
                }, {
                    value: 'buttons',
                    key: 'Button Radio',
                    icon:'buttons-radios'
                }, {
                    value: 'lineRadio',
                    key: 'Line Radio Buttons',
                    icon: 'line-radio'
                }],
            selectedValue: 'radio',
            selectedName: 'Flat Radio Buttons',
            selectedIcon:'flat-radio',
            onChangeFunction:'setDisplayFormat'
        },
        'Number' : {
            name: 'number.columns',
            selectedValue: 1,
            type: 'number',
            onChangeFunction: 'updateRows',
            min:'1',
            max:'999'
        },
        'Value': {
            hidden: true,
            selectedValue: ''
        },
        'Required': {
            name: 'required',
            selectedValue: false,
            type: 'checkbox'
        },
        'Name': {
            selectedValue: 'Basic',
            hidden: true
        }
    },
    Display: {
        'Read-only': {
            name: 'read.only',
            selectedValue: false,
            type: 'checkbox'
        },
        'Hidden': {
            name: 'hidden',
            selectedValue: false,
            type: 'checkbox'
        },
        'Name': {
            selectedValue: 'Display',
            hidden: true
        }
    },
    Style: angular.copy(Props.labelStyleObject),
    ControlStyle: angular.copy(Props.controlStyleObject),
    Margin: angular.copy(Props.marginObject),
    Advance: {
        'Tabindex': {
            name: 'tabindex',
            selectedValue: '',
            type: 'number'
        },
        'Searchable': angular.copy(Props.Searchable),
        'Reportable': angular.copy(Props.Reportable),
        'customizable-column': angular.copy(Props.Customizable),
        'Name': {
            selectedValue: 'Advanced',
            hidden: true
        }
    },
    Events: {
        Name: angular.copy(Props.elementEventsObject).Name,
        load: angular.copy(Props.elementEventsObject).load,
        change: angular.copy(Props.elementEventsObject).change
    },
    "Data Source": {
        'table': {
            type: 'table',
            headers: ['Label', 'Value', 'Default'],
            default: 'radio',
            list: [
                {
                    id: 1,
                    Label: {
                        name: 'Option 1',
                        type: 'text',
                        inputWidth: "width:100px;",
                        disable: false,
                    },
                    Value: {
                        name: '1',
                        type: 'text',
                        inputWidth: "width:100px;",
                        disable: false,
                    },
                    Default: {
                        name: "",
                        type: "radio",
                        inputWidth: "",
                        onChangeFunction: 'resetDefaultForRadio'
                    },
                    selectedValue: {
                        name: false,
                        type: 'checkbox',
                        inputWidth: "",
                        hidden: true
                    },
                    showUpdateOptions: true,
                    relation: {}
                },
                {
                    id: 2,
                    Label: {
                        name: 'Option 2',
                        type: 'text',
                        inputWidth: "width:100px;",
                        disable: false,
                    },
                    Value: {
                        name: '2',
                        type: 'text',
                        inputWidth: "width:100px;",
                        disable: false,
                    },
                    Default: {
                        name: "",
                        type: "radio",
                        inputWidth: "",
                        onChangeFunction: 'resetDefaultForRadio'
                    },
                    selectedValue: {
                        name: false,
                        type: 'checkbox',
                        inputWidth: "",
                        hidden: true
                    },
                    showUpdateOptions: true,
                    relation: {}
                }
            ],
        },
        'Name': {
            selectedValue: 'datasource',
            hidden: true
        }
    }
};

export default RadioProperties;


// WEBPACK FOOTER //
// ./client/app/localStorage/Controls/Radio.ts